export default /*@ngInject*/ function ($http, $rootScope, $q, $window, $location, $timeout, $route, $filter, applicationInsightsService, dataService) {
    
    if (!angular.isUndefined(MyApp.viewModelHelper)) {
        return MyApp.viewModelHelper($http, $rootScope, $q, $window, $location, $timeout, $route, $filter, applicationInsightsService, dataService);
    }
    else {
        return "";
    }
}